import e from "./generateUtilityClasses.mjs";
import i from "./generateUtilityClass.mjs";
function a(r) {
  return i("MuiCircularProgress", r);
}
const l = e("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
export {
  l as default,
  a as getCircularProgressUtilityClass
};
//# sourceMappingURL=circularProgressClasses.mjs.map
